


import arrow_top_right from './../media/icons/arrow_top_right.png'
import crisis_support from './../media/icons/crisis_support.png'
import arrow_left from './../media/icons/arrow_left.png'
import paper_plane from './../media/icons/send.png'
import spa_3d_female from './../media/icons/spa_3d_female.png'
import timer from './../media/icons/timer.png'
import lips from './../media/icons/lips.png'

import home from './../media/icons/home.png'
import heart from './../media/icons/heart.png'
import chart from './../media/icons/chart.png'
import connect from './../media/icons/connect.png'
import user from './../media/icons/user.png'
import emergency from './../media/icons/emergency.png'


import home_ia from './../media/icons/sidebar/home.png'
import heart_ia from './../media/icons/sidebar/heart.png'
import chart_ia from './../media/icons/sidebar/chart.png'
import connect_ia from './../media/icons/sidebar/connect.png'
import user_ia from './../media/icons/sidebar/user.png'
import emergency_red from './../media/icons/emergency_red.png'


import new_home from './../media/icons/n_sidebar/home.png'
import new_heart from './../media/icons/n_sidebar/heart.png'
import new_chart from './../media/icons/n_sidebar/bars.png'
import new_connect from './../media/icons/n_sidebar/user_group.png'
import new_user from './../media/icons/n_sidebar/user_check.png'


import new_home_ia from './../media/icons/home_ot.png'
import new_heart_ia from './../media/icons/heart_ot.png'
import new_chart_ia from './../media/icons/bars.png'
import new_connect_ia from './../media/icons/connect_ot.png'
import new_user_ia from './../media/icons/user_check.png'


import wallet from './../media/icons/wallet.png'
import menu from './../media/icons/menu.png'
import close from './../media/icons/close.png'
import menu_bar from './../media/icons/bar_menu.png'
import user_ot from './../media/icons/user_ot.png'

import angle_right_aqua from './../media/icons/angle_right_aqua.png'
import calender_edit from './../media/icons/calender_edit.png'
import pill from './../media/icons/pill.png'
import spa from './../media/icons/spa.png'
import ambulance from './../media/icons/ambulance.png'
import smile from './../media/icons/smile.png'
import plus from './../media/icons/plus.png'
import air from './../media/icons/air.png'
import wn_bars from './../media/icons/wn-bars.png'
import wallet_ot from './../media/icons/wallet_ot.png'

import angle_right from './../media/icons/angle_right.png'
import angle_left from './../media/icons/angle_left.png'

import heart_ecg from './../media/icons/heart_ecg.png'
import self_improvement from './../media/icons/self_improvement.png'
import moon from './../media/icons/moon.png'
import physical_health from './../media/icons/physical_health.png'
import stress_levels from './../media/icons/stress_levels.png'
import mental_state from './../media/icons/mental_state.png'
import sleep_quality from './../media/icons/sleep_quality.png'
import wellness_arrow_green from './../media/icons/wellness_arrow_green.png'
import wellness_arrow_red from './../media/icons/wellness_arrow_red.png'

import user_jog from './../media/icons/user_jog.png'
import leaf from './../media/icons/leaf.png'
import chair from './../media/icons/chair.png'

import home_health from './../media/icons/home_health.png'
import phone from './../media/icons/phone.png'
import comment from './../media/icons/comment.png'
import breif_case from './../media/icons/case.png'
import comment_fill from './../media/icons/comment_fill.png'
import videocam from './../media/icons/videocam.png'
import comment_ot from './../media/icons/comment_ot.png'
import briefcase_ot from './../media/icons/briefcase_ot.png'
import user_group from './../media/icons/user_group.png'
import smile_ot from './../media/icons/smile_ot.png'
import warn_ot from './../media/icons/warn.png'

import crown from './../media/icons/crown.png'
import crown_3d from './../media/icons/crown_3d.png'
import database from './../media/icons/database.png'
import bell from './../media/icons/bell.png'
import settings from './../media/icons/settings.png'
import user_shield from './../media/icons/user_shield.png'
import smart_phone from './../media/icons/smart_phone.png'
import bell_outline from './../media/icons/bell_outline.png'
import bell_p from './../media/icons/bell_p.png'
import bars_p from './../media/icons/bars_p.png'
import shield_p from './../media/icons/shield_p.png'
import link from './../media/icons/link.png'

import location from './../media/icons/location.png'
import briefcase from './../media/icons/briefcase.png'
import arrow_right_p from './../media/icons/arrow_right_p.png'
import spa_3d from './../media/icons/spa_3d.png'
import plus_p from './../media/icons/plus_p.png'

import location_blue from './../media/icons/location_blue.png'
import stress_management from './../media/icons/stress_management.png'
import phone_red from './../media/icons/phone_red.png'
import intelligence_network from './../media/icons/intelligence_network.png'
import bright from './../media/icons/bright.png'
import building from './../media/icons/building.png'
import hand_heart from './../media/icons/hand_heart.png'
import location_p from './../media/icons/location_p.png'
import call from './../media/icons/call.png'
import play from './../media/icons/play.png'

// import spa_l from './../media/icons/be/spa.png'
// import nose from './../media/icons/be/nose.png'
// import lips from './../media/icons/be/lips.png'

import file from './../media/icons/file.png'
import git from './../media/icons/git.png'
import stars from './../media/icons/stars.png'
import clock_rotate from './../media/icons/clock_rotate.png'
import clipboard from './../media/icons/clipboard.png'
import shield_check from './../media/icons/shield_check.png'
import cart from './../media/icons/cart.png'





export const icons = {
    
    general: {
        angle_right,
        angle_left,
        arrow_left,
        paper_plane,
        spa_3d_female,
        timer,
        lips,
    },

    webpage: {
        file,
        git,
        clock_rotate,
        stars,
        clipboard,
        shield_check,
        cart,
    },

    header: {
        wallet,
        menu,
        close,
        bell,
        bell_outline,
        menu_bar,
        user_ot,
    },

    sidebar: {
        active: {
            home,
            heart,
            chart,
            connect,
            user,
            emergency,

            new: {
                home: new_home,
                heart: new_heart,
                chart: new_chart,
                connect: new_connect,
                user: new_user,
            }

        },
        inactive: {
            home: home_ia, 
            heart: heart_ia,
            chart: chart_ia,
            connect: connect_ia,
            user: user_ia,
            emergency: emergency_red,
            
            new: {
                home: new_home_ia,
                heart: new_heart_ia,
                chart: new_chart_ia,
                connect: new_connect_ia,
                user: new_user_ia,
            }
        },
        crisis_support,
        arrow_top_right,
    },
    home: {
        angle_right_aqua,
        calender_edit,
        spa,
        pill,
        ambulance,
        smile,
        plus,
        air,
        wn_bars,
        wallet_ot,
    },

    wellness: {
        heart_ecg,
        self_improvement,
        moon,
        wellness_arrow_red,
        wellness_arrow_green,
        physical_health,
        mental_state,
        sleep_quality,
        stress_levels,
    },

    insights: {
        leaf,
        user_jog,
        chair,
    },

    connect: {
        phone,
        home_health,
        comment,
        breif_case,
        comment_fill,
        videocam,
        comment_ot,
        briefcase_ot,
        user_group,
        smile_ot,
        warn_ot,
    },

    profile: {
        crown,
        smart_phone,
        settings,
        bell,
        user_shield,
        database,
        crown_3d,
        bars_p,
        shield_p,
        bell_p,
        link,
    },

    rightbar: {
        location,
        briefcase,
        arrow_right_p,
        spa_3d,
        plus_p,
    },

    crisis: {
        location_blue,
        stress_management,
        phone_red,
        intelligence_network,
        crisis_support, 
        hand_heart,
        building,
        bright,
        play, 
        call,
        location_p,
    },

    // be: {
    //     spa: spa_l,
    //     nose,
    //     lips,
    // },

}